var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgWalletChecked = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 32,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#0E0E0E",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M24.053 18.067a2.68 2.68 0 0 0-.8 2.173c.12 1.44 1.44 2.494 2.88 2.494h2.534v1.586a5.025 5.025 0 0 1-5.014 5.014h-13.48a4.8 4.8 0 0 0 1.054-1.254c.493-.8.773-1.746.773-2.746a5.332 5.332 0 0 0-8.667-4.16v-5.827a5.025 5.025 0 0 1 5.014-5.013h15.306a5.025 5.025 0 0 1 5.014 5.013v1.92h-2.694c-.746 0-1.426.293-1.92.8"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#0E0E0E",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M3.333 16.547v-6.094c0-1.586.974-3 2.454-3.56l10.586-4c1.654-.626 3.427.6 3.427 2.374v5.066m10.278 8.294v2.747c0 .733-.586 1.333-1.333 1.36h-2.613c-1.44 0-2.76-1.054-2.88-2.494-.08-.84.24-1.626.8-2.173a2.66 2.66 0 0 1 1.92-.8h2.773a1.37 1.37 0 0 1 1.333 1.36M9.333 16h9.334"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  stroke: "#0E0E0E",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 1.5,
  d: "M12 25.333c0 1-.28 1.947-.773 2.747-.28.48-.64.907-1.054 1.253a5.2 5.2 0 0 1-3.506 1.334 5.29 5.29 0 0 1-4.56-2.587 5.23 5.23 0 0 1-.774-2.747c0-1.68.774-3.186 2-4.16A5.332 5.332 0 0 1 12 25.333"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  stroke: "#0E0E0E",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "m4.589 25.333 1.32 1.32 2.84-2.627"
})));
export default SvgWalletChecked;